import { ContainerModule } from 'inversify';
import NPSService from 'src/features/nps/data/service/NPSService';
import { NPSServiceInterface } from 'src/features/nps/data/service/NPSService.types';
import SendNPSUseCase from 'src/features/nps/domain/useCases/SendNPSUseCase';
import GetNPSByUserUuidUseCase from 'src/features/nps/domain/useCases/GetNPSByUserUuidUseCase';

export const npsBindings = new ContainerModule((bind) => {
  bind<NPSServiceInterface>(NPSService).to(NPSService);
  bind<SendNPSUseCase>(SendNPSUseCase).to(SendNPSUseCase);
  bind<GetNPSByUserUuidUseCase>(GetNPSByUserUuidUseCase).to(
    GetNPSByUserUuidUseCase
  );
});
